import { render, staticRenderFns } from "./LoadingOwl.vue?vue&type=template&id=b5e105ce&scoped=true&"
import script from "./LoadingOwl.vue?vue&type=script&lang=js&"
export * from "./LoadingOwl.vue?vue&type=script&lang=js&"
import style0 from "./LoadingOwl.vue?vue&type=style&index=0&id=b5e105ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5e105ce",
  null
  
)

export default component.exports